module.exports = "/_next/static/images/bag_drink-5675023e1b30f97c6ad001589c505f3c.jpg";